export const QUOTATION_PAYMENT_SUBMIT = "@QUOTATION_PAYMENT/SUBMIT";
export const QUOTATION_PAYMENT_OPEN_POPUP = "@QUOTATION_PAYMENT/OPEN_POPUP";
export const QUOTATION_PAYMENT_CLOSE_POPUP = "@QUOTATION_PAYMENT/CLOSE_POPUP";
export const QUOTATION_PAYMENT_SET_CARD_PAYFORM_CONFIGURATION =
    "@QUOTATION_PAYMENT/SET_CARD_PAYFORM_CONFIGURATION";
export const QUOTATION_PAYMENT_LOAD_NIUBIZ_SESSION =
    "@QUOTATION_PAYMENT/LOAD_NIUBIZ_SESSION";
